import type { ButtonHTMLAttributes, ReactNode } from 'react'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'outline'
  size?: 'sm' | 'md' | 'lg'
  icon?: ReactNode
}

export function Button({ variant = 'primary', size, icon, className = '', children, ...props }: ButtonProps) {
  let btnClass = 'btn-primary'
  
  if (variant === 'secondary') btnClass = 'btn-secondary'
  if (variant === 'danger') btnClass = 'btn-danger'
  if (variant === 'outline') btnClass = 'btn-outline'
  if (variant === 'ghost') btnClass = 'btn-ghost'
  
  const sizeClass = size ? `btn-${size}` : ''
  
  return (
    <button className={`${btnClass} ${sizeClass} ${className}`.trim()} {...props}>
      {icon && <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</span>}
      {children}
    </button>
  )
}
